import { isBefore, parse } from "date-fns";
import { dateFormat } from "../Shared";
export default function filterDataAfterDate(data, lastDate) {
    return data.filter((d) => isBefore(parse(d.endDate, dateFormat, new Date()), lastDate));
}
//# sourceMappingURL=filterDataAfterDate.js.map